import React, { useEffect, useState } from 'react';
import { useMsal } from "@azure/msal-react";
import { connect, useDispatch } from 'react-redux';
import { Outlet } from "react-router-dom";
import { loginRequest } from "../../authConfig";
import { callMsGraph } from "../../graph";
import isLoggedIn, { saveLogin } from '../../utils/auth';
import * as authConstants from '../../constants/auth';
import { history } from '../../store';

import { authSave, fetchAppCredentials } from "../../actions/auth";


let allActionCreators = Object.assign({});


const RequestProfileDataController = () => {
    const { instance, accounts } = useMsal();
    const [graphData, setGraphData] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
      RequestProfileData();
    }, []);

    function RequestProfileData() {
      const poll = setInterval(() => {
        if(isLoggedIn()) {
          clearInterval(poll);
        } else {
          RequestProfileDataCall();
        }
      }, 2000);
    }

    function RequestProfileDataCall() {

      instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
      }).then(async (response) => {

          callMsGraph(response.accessToken)
         .then(response => {
            
           if(!response) {
            return null;
           }

           fetchAppCredentials(response.mail)
            .then((d_resp) => {

              const e_resp = d_resp();
              const f_resp = Promise.resolve(e_resp);

              f_resp.then((msAuthResp) => {

                saveLogin(msAuthResp.auth.auth_token, msAuthResp.auth.admin, msAuthResp.auth.role, msAuthResp.auth.remote, msAuthResp.auth.user.id, msAuthResp.auth.user);
                dispatch(authSave(msAuthResp.auth.auth_token, msAuthResp.auth.admin, msAuthResp.auth.role, Date.now() + authConstants.LOGOUT_TIME, msAuthResp.auth.user.id));

                if(msAuthResp.auth.need_password_reset) {
                  history.push('/update-password');
                }
              });


            });

           setGraphData(response)
         });
      }).catch((err) => {
       console.error(err);
      });
    }

    return null;
};


export const AppMsAuth = () => {

    const { instance, accounts } = useMsal();

    useEffect(() => {
      // RequestProfileDataController();
    }, []);

    return (
      <div className='AppMsAuth'>
        <div className='authBody'>
          <RequestProfileDataController />
          <Outlet />
        </div>
      </div>
    );
}

function mapStateToProps(state) {
  return {

  };
}

export default connect(mapStateToProps, { fetchAppCredentials })(AppMsAuth);





